import { Component, OnInit } from '@angular/core';
import { from } from 'rxjs';

@Component({
  selector: 'app-mcredpro',
  templateUrl: './mcredpro.component.html',
  styleUrls: ['./mcredpro.component.scss']
})
export class McredproComponent implements OnInit {

  constructor(

  ) { }

  ngOnInit() {

    document.querySelector("body").classList.remove("move-main-panel");

    (<any>$('.boxshadesh')).hover(
      function(){
        $(".boxshadesh.active").addClass('inactive').removeClass('active');
      },
      function(){
        $(".boxshadesh.inactive").addClass('active').removeClass('inactive');
      }
    );

    $('a').hover(
      function(){
        $("a.active").addClass('inactive').removeClass('active');
      },
      function(){
        $("a.inactive").addClass('active').removeClass('inactive');
      }
    );

    // (<any>$(document)).ready(function(){
    //   (<any>$(window)).scroll(function () {
    //       if ($(this).scrollTop() > 50) {
    //         $('#back-to-top').fadeIn();
    //       } else {
    //         $('#back-to-top').fadeOut();
    //       }
    //     });
    //     // scroll body to 0px on click
    //     (<any>$('#back-to-top')).click(function () {
    //       $('body,html').animate({
    //         scrollTop: 0
    //       }, 400);
    //       return false;
    //     });
    // });
  }

}
